// composables/useIsSignedIn.js
import {ref} from "vue";

function intersection(arr1, arr2) {
  if (!Array.isArray(arr1) || !Array.isArray(arr2)) return [];
  return arr1.filter((item) => arr2.includes(item));
}

export default function useIsSignedIn() {
  const userEvents = ref(JSON.parse(localStorage.getItem("events") || "{}"));

  const check = (toArray = []) => {
    if (toArray.length === 0) return Object.keys(userEvents.value);
    const signedInEvents = intersection(Object.keys(userEvents.value), toArray);
    return signedInEvents.length > 0;
  };

  return check;
}
